import { FC } from "react";
import { Box, Typography } from "@mui/material";

type RevenueChartProps = {
  label: string;
  value: number;
};

export const RevenueChart: FC<RevenueChartProps> = ({ label, value }) => {
  const formattedValue = value.toLocaleString("en-US");

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={2}
    >
      <Typography
        variant="subtitle2"
        sx={{
          color: label.toLowerCase() === "today" ? "#118c4f" : "text.primary",
          fontWeight: 600,
          fontSize: "1.2rem",
          letterSpacing: "0.5px",
          mt: 2,
          mb: 0.5,
        }}
      >
        {label.toUpperCase()}
      </Typography>
      <Box display="flex" alignItems="flex-start" gap={0.25}>
        <Typography
          sx={{
            fontSize: "1rem",
            lineHeight: 1.1,
            color:
              label.toLowerCase() === "today"
                ? "#118C4F"
                : "rgba(0, 0, 0, 0.8)",
            fontWeight: 600,
          }}
        >
          $
        </Typography>
        <Typography
          sx={{
            fontSize: "1.5rem",
            lineHeight: 1.1,
            color:
              label.toLowerCase() === "today"
                ? "#118C4F"
                : "rgba(0, 0, 0, 0.8)",
            fontWeight: 700,
          }}
        >
          {formattedValue}
        </Typography>
      </Box>
    </Box>
  );
};
